// extracted by mini-css-extract-plugin
export default {"button":"button___s7ebw","disabled":"disabled___xp236"};